export default __webpack_public_path__ + "static/media/img-0706-belgium-full-face.bce98fb3.png";